import { Locale } from "../Locale.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getCartPaymentDeliveryPath(locale: Locale): string {
	return getPathInLocale(locale, {
		[Locale.cs]: "/kosik/doprava-a-platba",
	});
}
